import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import UUID from 'vue-uuid'
import {InlineSvgPlugin} from 'vue-inline-svg';
import { i18n } from './plugins/i18n.js';

import { routes } from './routes';
import { store } from './store/index'

require('script-loader!blueimp-file-upload/js/vendor/jquery.ui.widget.js');
require('script-loader!blueimp-load-image/js/load-image.all.min.js');
require('script-loader!blueimp-canvas-to-blob/js/canvas-to-blob.js');
require('script-loader!blueimp-file-upload/js/jquery.iframe-transport.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-process.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-image.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-audio.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-video.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-validate.js');
require('script-loader!blueimp-file-upload/js/jquery.fileupload-ui.js');

Vue.use(UUID);
Vue.use(InlineSvgPlugin);
Vue.use(VueRouter);

Vue.config.productionTip = false

const router = new VueRouter({
  routes,
  base: '/',
  mode: 'hash'
})

new Vue({
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app')